import { useTranslation } from 'react-i18next';

import type { LearningStats } from '@/shared/api/types';

import styles from './Learning.module.css';

/**
 * Single numbers are tiles, not charts: recall over the month, the week's
 * time and answers, and where the cards are on their way.
 */
export function StatTiles({ stats }: { stats: LearningStats }): React.JSX.Element {
  const { t, i18n } = useTranslation();
  const percent = new Intl.NumberFormat(i18n.language, { style: 'percent' });
  const recall =
    stats.recall_reviews > 0 ? percent.format(stats.recall_successes / stats.recall_reviews) : '—';
  const learning = stats.stages.learning + stats.stages.relearning;

  const tiles = [
    {
      key: 'recall',
      value: recall,
      label: t('dashboard.recall'),
      hint: t('dashboard.recallHint', { count: stats.recall_reviews }),
    },
    {
      key: 'week',
      value: t('dashboard.minutesValue', { count: Math.round(stats.week_seconds / 60) }),
      label: t('dashboard.week'),
      hint: t('dashboard.weekHint', { count: stats.week_reviews }),
    },
    { key: 'new', value: String(stats.stages.new), label: t('dashboard.stageNew') },
    { key: 'learning', value: String(learning), label: t('dashboard.stageLearning') },
    { key: 'review', value: String(stats.stages.review), label: t('dashboard.stageReview') },
  ];

  return (
    <dl className={styles.tiles}>
      {tiles.map((tile) => (
        <div key={tile.key} className={styles.tile}>
          <dt className={styles.tileLabel}>{tile.label}</dt>
          <dd className={styles.tileValue}>{tile.value}</dd>
          {tile.hint !== undefined && <dd className={styles.tileHint}>{tile.hint}</dd>}
        </div>
      ))}
    </dl>
  );
}
